/**
 * 配置中的dep
 * 详细范例https://wiki.corp.kuaishou.com/pages/viewpage.action?pageId=102786580
 * 拥有以下属性：
 * listen       依赖组件的全局ID
 * event        监听的事件
 * source       取监听组件的某值（其属性值或是输出数据值）
 * formatter {  本地格式化函数（见./formatters）
 *      name: ["compare", "lessThan"],
 *      extra: "[3]"
 * }
 * destination  输出位置（自身属性值或是对应数据的值）
 */

class ComponentConfigDep {
    constructor(dep) {
        if (typeof dep !== 'object' || !dep) {
            // 不为object类型或者null
            // eslint-disable-next-line
            console.warn('[dep in config.deps must be an object');
            dep = {};
        }
        this.listen = dep.listen || '';
        this.event = dep.event || '';
        this.source = dep.source || '';
        this.formatter = dep.formatter || {
            name: [],
            extra: '',
        };
        // 覆盖非法值时留一个特殊的输出位置
        // 避免输出值位置为空字符串导致props被覆盖
        this.destination = typeof dep.destination === 'string'
            ? dep.destination
            : '_unknownProps';
    }
}

export default ComponentConfigDep;
